export const PaymentBadge = ({ status }) => {
  const map = {
    paid: { label: "Payé", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
    pending: { label: "En attente de paiement", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  };
  const s = map[status] || map.pending;
  return (
    <span data-testid={`payment-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold ${s.cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

const REPORT_MAP = {
  awaiting_report: { label: "En attente du rapport", cls: "bg-slate-100 text-slate-600" },
  provisional: { label: "Provisoire — chez le client", cls: "bg-blue-100 text-blue-700" },
  revision_requested: { label: "Corrections demandées", cls: "bg-orange-100 text-orange-700" },
  validated: { label: "Validé — définitif à poster", cls: "bg-violet-100 text-violet-700" },
  definitive: { label: "Définitif — chez le client", cls: "bg-emerald-100 text-emerald-700" },
};

export const ReportBadge = ({ status, paid }) => {
  let s = REPORT_MAP[status] || REPORT_MAP.awaiting_report;
  if (paid === false && status === "provisional")
    s = { label: "Provisoire prêt — client pas encore payé", cls: "bg-amber-100 text-amber-700" };
  if (paid === false && status === "definitive")
    s = { label: "Définitif prêt — client pas encore payé", cls: "bg-amber-100 text-amber-700" };
  return (
    <span data-testid={`report-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const PaymentMomentBadge = ({ label }) => (
  <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-slate-50 text-slate-700 border border-slate-200">
    {label}
  </span>
);
